import { App as AntdApp, Modal, message } from 'antd';
import { useEffect } from 'react';

export default function MonkeyPatchModal() {
  const { modal, message: appMessage } = AntdApp.useApp();

  useEffect(() => {
    // 保存原始的 Modal
    const originalModal = { ...Modal };

    // 重写
    Modal.confirm = modal.confirm;
    Modal.info = modal.info;
    Modal.success = modal.success;
    Modal.error = modal.error;
    Modal.warning = modal.warning;

    // 可选：卸载时恢复原始
    return () => {
      Modal.confirm = originalModal.confirm;
      Modal.info = originalModal.info;
      Modal.success = originalModal.success;
      Modal.error = originalModal.error;
      Modal.warning = originalModal.warning;
    };
  }, [modal]);

  useEffect(() => {
    // 保存原始的 message
    const originalMessage = { ...message };

    // 重写 message 静态方法， 使用 App context 中的 message
    message.info = appMessage.info;
    message.success = appMessage.success;
    message.error = appMessage.error;
    message.warning = appMessage.warning;
    message.loading = appMessage.loading;
    message.destroy = appMessage.destroy;

    // 可选：卸载时恢复原始
    return () => {
      message.info = originalMessage.info;
      message.success = originalMessage.success;
      message.error = originalMessage.error;
      message.warning = originalMessage.warning;
      message.loading = originalMessage.loading;
      message.destroy = originalMessage.destroy;
    };
  }, [appMessage])

  return null;
}
